import React, {useContext} from "react";
import Link from "next/link";
import {safeHTML} from "../../utils/safeHTML";
import {useDispatch} from "react-redux";
import {changeFilter} from "../../redux/reducer/panel";
import {BreadcrumbsContext} from "../layouts/MainLayout";
import styles from "./Breadcrumbs.module.scss";

const testData = [
  {name: 'Главная'},
  {name: 'Разбор'},
  {name: 'Лотерейный гороскоп: что вас ждёт на этой неделе'}
]

const Breadcrumbs = React.forwardRef(
  function Breadcrumbs({}, ref) {
    const dispatch = useDispatch();
    const breadcrumbs = useContext(BreadcrumbsContext)

    const crumbs = breadcrumbs?.map(({name, href}, index) => {
      return <div key={`item-key-${index}`}
                  className={styles.breadcrumbs__item}
                  onClick={() => {
                    dispatch(changeFilter(href.slice(1)));
                  }}>
        <Link legacyBehavior href={href || ''} className={styles.breadcrumbs__itemName}>{<a>{safeHTML(name)}</a>}</Link>
      </div>
    })

    return (
      <div className={styles.breadcrumbs} ref={ref}>
        {breadcrumbs?.length > 1 && crumbs}
      </div>
    );
  });
export default Breadcrumbs;
Breadcrumbs.propTypes = {};

